// extracted by mini-css-extract-plugin
module.exports = {"root":"Dashboard_root__29oPL","main":"Dashboard_main__2F4tr"};